import { ApiClient } from "../ApiClient";

const INSTITUTION_BALANCES_ENDPOINT = "finances/balances/";
const BALANCES_HISTORY_ENDPOINT = "finances/balances/history/";

/**
 * Fetches current balances for all institutions.
 */
export const getInstitutionBalances = async ({
  includeInactive = false,
} = {}) => {
  const queryString = includeInactive ? "?include_inactive=true" : "";
  const res = await ApiClient.get(
    `${INSTITUTION_BALANCES_ENDPOINT}${queryString}`,
  );
  return await res.json();
};

/**
 * Fetches aggregated balance history.
 * Handles params correctly by converting them to a query string.
 */
export const getBalanceHistory = async (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  const url = queryString
    ? `${BALANCES_HISTORY_ENDPOINT}?${queryString}`
    : BALANCES_HISTORY_ENDPOINT;

  const res = await ApiClient.get(url);
  return await res.json();
};

/**
 * Specifically fetches data formatted for the MoneyStreamline chart.
 */
export const getBalanceStreamline = async (institutionUuid = null) => {
  let url = `${BALANCES_HISTORY_ENDPOINT}?view=streamline`;

  if (institutionUuid) {
    url += `&institution_uuid=${institutionUuid}`;
  }

  const res = await ApiClient.get(url);
  return await res.json();
};
